import {Controller} from "stimulus";
import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.min.css";
import {useDispatch} from "stimulus-use";
import {CheckoutStorageHandler} from "util/checkout_storage_handler";


export default class extends Controller {
    static targets = [
        'selectedOption', 'list', 'listItems',
        'container', 'option', 'selected',
        'state', 'country', "hiddenInput"
    ]

    connect() {
        useDispatch(this);
        document.addEventListener('click', this.handleOutsideClick.bind(this));
        document.addEventListener('updateOptions', this.updateOptions.bind(this));

        this.createCustomScroll();
        this._observeHiddenInput();

        if (this.hasHiddenInputTarget && this.hiddenInputTarget.value) {
            this.handleSelectItem({
                detail: {
                    activeValue: this.hiddenInputTarget.value,
                    dispatchEvent: false
                }
            })
        }
    }
    createCustomScroll() {
        new SimpleBar(this.listItemsTarget, {
            autoHide: false,
            clickOnTrack: false,
        });
    }

    updateStates(payload) {
        setTimeout(() => {
            this.dispatchCustomEvent(null, payload)
        }, 1000)
    }

    closeAllDropdowns() {
        if (!this.containerTarget.classList.contains('active')) return;

        const arrowSvg = this.containerTarget.querySelector('.select-field-arrow svg');

        this.containerTarget.classList.remove('active');
        this.listTarget.classList.toggle('active');
        arrowSvg.classList.remove('active');
        this._checkRequired()
    }

    handleOutsideClick(event) {
        if (!(this.element === event.target || this.element.contains(event.target))) {
            this.listTargets.forEach(dropdown => {
                if (dropdown.classList.contains("active")) {
                    const eventState = new CustomEvent("option-selected", {
                        detail: {
                            target: "state",
                            value: ''
                        }
                    });

                    window.dispatchEvent(eventState);
                }
            });

            this.closeAllDropdowns();
        }
    }

    toggleDropdown() {
        const arrowSvg = this.containerTarget.querySelector('.select-field-arrow svg');

        this.containerTarget.classList.toggle('active');
        arrowSvg.classList.toggle('active');
        this.listTarget.classList.toggle('active');
        this._checkRequired()
    }

    search(event) {
        const searchInput = event.target.value.toLowerCase();
        const currentContainer = this.containerTargets.find(target => target.contains(event.currentTarget))
        const options = this.optionTargets.filter(target => currentContainer.contains(target))
        const hiddenInput = this.hiddenInputTargets.find(target => currentContainer.contains(target))
        const optionLength = options.length;
        options.forEach((option) => {

            const itemName = option.textContent.toLowerCase();

            if (itemName.includes(searchInput)) { // if the name of the menu item is the same as whatever is inputted in the search field
                option.classList.remove("hidden"); // display the menu card of the menu item
            } else {
                option.classList.add("hidden"); // hide the menu card of all the items that do not match the input
            }
        });

        const visibleOptions = options.filter(option => !option.classList.contains('hidden'));

        if (visibleOptions.length === 1) {
            hiddenInput.value = visibleOptions[0].dataset.value
            this.dispatchCustomEvent(event)
        }

        if (searchInput === "") {
            hiddenInput.value = '';
            this.dispatchCustomEvent(event)
        }

    }

    setValue() {
        let value = this.hiddenInputTarget.value;
        let option = this.listItemsTarget.querySelector(`[data-value="${value}"]`);

        if (!option) {
            option = this.listItemsTarget.querySelector(`[data-name="${value}"]`);
            this.hiddenInputTarget.value = option.dataset.value;
            value = option.dataset.value;
        }

        if (option) {
            this.handleSelectItem({detail: {activeValue: value, dispatchEvent: false}})
        }
    }

    updateSelectedValue() {
        const value = this.selectedOptionTarget.value;
        let option = this.listItemsTarget.querySelector(`[data-name="${value}"]`);
        if (!option) {
            option = this.listItemsTarget.querySelector(`[data-value="${value}"]`);
        }

        if (option) {
            this.handleSelectItem({
                detail: {
                    activeValue: option.dataset.value, dispatchEvent: false
                }})
        }
    }

    handleSelectItem({detail: {activeValue, dispatchEvent = true}}) {
        const activeItem = this.listItemsTarget.querySelector(`[data-value="${activeValue}"]`);
        this.hiddenInputTarget.value = activeValue || "";
        if (dispatchEvent)
            this.hiddenInputTarget.dispatchEvent(new Event('change'));

        if (this.selectedOption)
            this.selectedOption.classList.remove('selected');

        this.selectedOption = activeItem;
        this.selectedOption.classList.add('selected');
        this.selectedOptionTarget.value = activeItem.textContent.trim().replace(/([^\.\s])\s{2,}/gm, '$1');

        if (activeItem && activeItem.offsetTop > 180) {
            const targetTop = activeItem.getBoundingClientRect().top;
            const scrollerTop = this.listTarget.getBoundingClientRect().top;
            const scrollTop = targetTop - scrollerTop + this.listTarget.scrollTop;
            this.listTarget.scrollTo({
                top: scrollTop,
                behavior: 'smooth'
            });
            Object.fromEntries(this.listItemsTarget.children).forEach(item => item.classList.remove("selected"));
            activeItem.classList.add("selected");
        }
    }

    removeSelectedItems(items, parentElement) {
        items.forEach((item) => {
            if (item.parentElement === parentElement) {
                item.classList.remove('selected');
            }
        })
    }

    selectOption(event) {
        if (!this.selectedOption) {
            this.selectedOption = event.currentTarget
            this.selectedOption.classList.add('selected')
        } else if (this.selectedOption !== event.currentTarget) {
            this.selectedOption.classList.remove('selected')
            this.selectedOption = event.currentTarget
            this.selectedOption.classList.add('selected')
        }

        this.hiddenInputTarget.value = event.currentTarget.dataset.value || '';
        this.hiddenInputTarget.dispatchEvent(new Event('change'));

        this.selectedOptionTarget.value = event.currentTarget.textContent.trim().replace(/([^\.\s])\s{2,}/gm, '$1');

        this.toggleDropdown(event);
        this.dispatchCustomEvent(event)
    }

    updateOptions({ detail: { options } }) {
        const currentValue = this.hiddenInputTarget.value;

        this.listItemsTarget.innerHTML = "";
        options.forEach(option => {
            const optionElement = document.createElement("li");
            optionElement.classList.add("dropdown-item");
            optionElement.dataset.name = option.name;
            optionElement.dataset.value = option.shortCode;
            optionElement.dataset.action = "click->select-input#selectOption";
            optionElement.dataset.target = "select-input.option";
            optionElement.textContent = option.name;
            this.listItemsTarget.appendChild(optionElement);
        })
        this.createCustomScroll();

        if (currentValue) {
            const currentOption = this.listItemsTarget.querySelector(`[data-value="${currentValue}"]`);
            if (currentOption) {
                this.handleSelectItem({detail: {activeValue: currentValue}})
            }
        }
    }

    dispatchCustomEvent(e, payload) {
        const event = new CustomEvent("option-selected", {
            detail: payload || {
                target: e.target.dataset.name,
                value: e.target.dataset.value
            }
        });

        window.dispatchEvent(event);
    }

    _observeHiddenInput() {
        const observer = new MutationObserver(() => {
            this.updateSelectedValue()
        });

        observer.observe(this.selectedOptionTarget, {
            attributes: true,
            attributeFilter: ['value']
        })
    }

    _checkRequired() {
        if (this.hiddenInputTarget.value === "") {
            this.containerTarget.classList.add('error');
        } else {
            this.containerTarget.classList.remove('error');
        }
    }
}
